import './App.css';
import { BrowserRouter as Router, Routes, Route, Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import heroImage from './hero-image.png'; // Importamos la imagen del hero

// Componente de Navegación que aparece en todas las páginas
function Navigation() {
  // Usamos window.location para una solución más simple sin Routes anidados
  const pathname = window.location.pathname;
  const isHomePage = pathname === '/';
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    // Solo aplicamos los efectos de scroll en la página de inicio
    if (isHomePage) {
      // Inicialmente aplicamos un estilo que depende de la posición actual del scroll
      if (window.scrollY > 50) {
        setScrolled(true);
      }
      
      const handleScroll = () => {
        if (window.scrollY > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
      
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    } else {
      // En páginas internas, no necesitamos efectos de scroll
      setScrolled(false);
    }
  }, [isHomePage]);
  
  return (
    <nav className={`main-nav ${!isHomePage ? 'internal-page-nav' : ''} ${isHomePage && scrolled ? 'scrolled-nav' : ''}`}>
      <div className="nav-container">
        <div className="logo">
          <Link to="/">
            <img src="/images/whitelogo.png" alt="Pashanga" />
          </Link>
        </div>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/catalog">Catalog</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
}

// Página de inicio
function Home() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  
  const goToCategory = (category) => {
    navigate(`/catalog/${category}`);
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <>
      <section id="home" className="hero">
        <img 
          src={heroImage} 
          alt="Hero" 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 1
          }}
        />
        <div className="hero-content">
          <div className={`hero-text-container ${isVisible ? 'visible' : ''}`}>
            <h1 className="hero-title">AUTHENTIC LATIN<br/>AMERICAN FLAVORS</h1>
            <p className="hero-subtitle">Discover the true essence of our culture through traditional flavors</p>
            <div className="hero-buttons">
              <button className="btn primary-btn" onClick={() => goToCategory('empanadas')}>EXPLORE NOW</button>
              <button className="btn secondary-btn" onClick={() => navigate('/about')}>OUR STORY</button>
            </div>
          </div>
        </div>
        <div className="hero-scroll-indicator">
          <span>Scroll down</span>
          <div className="scroll-arrow"></div>
        </div>
      </section>

      <section className="featured-products">
        <div className="section-header">
          <h2>FEATURED PRODUCTS</h2>
          <div className="section-divider"></div>
          <p>Our most popular Latin American specialties</p>
        </div>
        
        <div className="featured-grid">
          <div className="featured-item large" onClick={() => goToCategory('bites')}>
            <div className="featured-image">
              <img src="/images/Bites.png" alt="Bites Destacados" />
              <div className="featured-overlay">
                <div className="featured-content">
                  <h3>BITES</h3>
                  <p>Small bites of intense flavor</p>
                  <span className="view-more">VIEW MORE</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="featured-item" onClick={() => goToCategory('empanadas')}>
            <div className="featured-image">
              <img src="/images/Empanadas.png" alt="Empanadas" />
              <div className="featured-overlay">
                <div className="featured-content">
                  <h3>EMPANADAS</h3>
                  <span className="view-more">VIEW MORE</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="featured-item" onClick={() => goToCategory('prepared-meals')}>
            <div className="featured-image">
              <img src="/images/Mechada.png" alt="Prepared Meals" />
              <div className="featured-overlay">
                <div className="featured-content">
                  <h3>PREPARED MEALS</h3>
                  <span className="view-more">VIEW MORE</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="flavor-section">
        <div className="parallax-background"></div>
        <div className="flavor-container">
          <div className="flavor-text">
            <span className="flavor-badge">SPECIALTY</span>
            <h2>AUTHENTIC LATIN<br/>AMERICAN FLAVORS</h2>
            <p>Discover the vibrant and delicious experience of Latin American flavors with our irresistible bites and appetizers.</p>
            <button className="btn primary-btn" onClick={() => goToCategory('bites')}>EXPLORE BITES</button>
          </div>
          <div className="flavor-image">
            <div className="image-frame">
              <img src="/images/Bites.png" alt="Delicious Latin Bites" />
            </div>
          </div>
        </div>
      </section>


      <section className="testimonials">
        <div className="testimonials-background"></div>
        <div className="section-header light">
          <h2>WHAT OUR CUSTOMERS SAY</h2>
          <div className="section-divider"></div>
        </div>
        
        <div className="testimonials-slider">
          <div className="testimonial-card">
            <div className="quote-mark">"</div>
            <p className="testimonial-text">Pashanga's empanadas are simply incredible. The authentic flavor transports me directly to Latin America.</p>
            <div className="testimonial-author">
              <h4>Maria Garcia</h4>
              <p>Regular Customer</p>
            </div>
          </div>
          
          <div className="testimonial-card">
            <div className="quote-mark">"</div>
            <p className="testimonial-text">I've never tasted pulled beef so tender and flavorful. It's my favorite order for any family event.</p>
            <div className="testimonial-author">
              <h4>John Rodriguez</h4>
              <p>Professional Chef</p>
            </div>
          </div>
          
          <div className="testimonial-card">
            <div className="quote-mark">"</div>
            <p className="testimonial-text">The bites are perfect for any gathering. They're always the center of attention at my parties.</p>
            <div className="testimonial-author">
              <h4>Caroline Martinez</h4>
              <p>Event Organizer</p>
            </div>
          </div>
        </div>
      </section>

      <section className="party-section">
        <div className="party-container">
          <h2>READY TO CELEBRATE?</h2>
          <p>Celebrate with our festive and flavorful Latin dishes</p>
          <button className="btn primary-btn" onClick={() => navigate('/contact')}>CONTACT US NOW</button>
        </div>
      </section>
      
      <section className="instagram-feed">
        <div className="section-header">
          <h2>FOLLOW US ON INSTAGRAM</h2>
          <div className="section-divider"></div>
          <p>@pashanga_official</p>
        </div>
        
        <div className="instagram-grid">
          <div className="instagram-item">
            <img src="/images/Mini Empanada Empanada Beef.png" alt="Instagram Post" />
            <div className="instagram-overlay">
              <i className="instagram-icon">♥</i>
            </div>
          </div>
          <div className="instagram-item">
            <img src="/images/Empanadas.png" alt="Instagram Post" />
            <div className="instagram-overlay">
              <i className="instagram-icon">♥</i>
            </div>
          </div>
          <div className="instagram-item">
            <img src="/images/Mechada.png" alt="Instagram Post" />
            <div className="instagram-overlay">
              <i className="instagram-icon">♥</i>
            </div>
          </div>
          <div className="instagram-item">
            <img src="/images/venezolanas.png" alt="Instagram Post" />
            <div className="instagram-overlay">
              <i className="instagram-icon">♥</i>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

// Base de datos de productos por categorías
const productsData = {
  'bites': [
    { 
      id: 'yuca-cheese', 
      name: 'Yuca and Cheese', 
      images: [ '/images/yuca and cheese 2.png','/images/yuca and cheese.png'], 
      description: 'Delicious yuca and cheese bites, perfect for any occasion.', 
      longDescription: `Our Yuca and Cheese bites are a perfect blend of creamy cheese and perfectly cooked yuca. These delightful treats are crispy on the outside and soft on the inside, making them the perfect appetizer for any gathering. Made with authentic Latin American flavors, these bites will transport you straight to the heart of South America.`,
      pairings: [
        { 
          name: 'Guava Spicy Sauce', 
          image: '/images/guava-spicy-sauce.jpg',
          description: 'Sweet-heat contrast brightens the mild yuca and creamy cheese.'
        },
        { 
          name: 'Garlic-Cilantro Cream', 
          image: '/images/garlic-cilantro-cream.jpg',
          description: 'Herbaceous & garlicky notes cut through richness and add freshness.'
        },
        { 
          name: 'Classic Green Chimichurri + Lime', 
          image: '/images/chimichurri-lime.jpg',
          description: 'Tangy herbs balance the cheesy center and keep every bite vibrant.'
        },
        { 
          name: 'Aji Amarillo Honey', 
          image: '/images/aji-amarillo-honey.jpg',
          description: 'Tropical sweetness with a hint of chili makes the flavors pop.'
        },
        { 
          name: 'Passion-Fruit Margarita / Mocktail', 
          image: '/images/passion-fruit-drink.jpg',
          description: 'Tart bubbles cleanse the palate and complement Latin-tropical vibes.'
        },
        { 
          name: 'Light Craft Lager', 
          image: '/images/craft-lager.jpg',
          description: 'Crisp, dry finish refreshes without overshadowing the bites.'
        }
      ]
    },
    { 
      id: 'yuca-beef', 
      name: 'Yuca and Beef', 
      images: ['/images/Yuca and Beef.png', '/images/yuca-beef-2.jpg'], 
      description: 'Savory yuca and beef bites, a crowd favorite.', 
      longDescription: `Our Yuca and Beef bites combine tender, slow-cooked beef with perfectly fried yuca for a savory treat that will wow your guests. Each bite is packed with authentic Latin flavors and spices that create a perfect balance of texture and taste. Perfect for parties, gatherings, or simply as a delicious snack any day of the week.`,
      pairings: [
        { 
          name: 'Smoky Chipotle-Tomato Salsa', 
          image: '/images/chipotle-tomato-salsa.jpg',
          description: 'Echoes the savory beef filling while adding a gentle smoke & heat that perks up the mild yuca shell.'
        },
        { 
          name: 'Garlic-Cilantro Crema', 
          image: '/images/garlic-cilantro-crema.jpg',
          description: 'Cool, tangy dairy + herbs balance the rich shredded beef and keep every bite fresh.'
        },
        { 
          name: 'Sweet Plantain Ketchup', 
          image: '/images/plantain-ketchup.jpg',
          description: 'A touch of caramelized sweetness from ripe plantains highlights the Latin profile and contrasts the beef\'s umami.'
        },
        { 
          name: 'Green Aji Verde', 
          image: '/images/aji-verde.jpg',
          description: 'Bright Peruvian pepper sauce cuts through fat with citrus and spice, amplifying the yuca\'s earthy notes.'
        },
        { 
          name: 'Pineapple Habanero Chutney', 
          image: '/images/pineapple-habanero.jpg',
          description: 'Sweet-heat burst cleanses the palate and gives a tropical twist without overpowering.'
        },
        { 
          name: 'Amber Lager or Vienna-style Beer', 
          image: '/images/amber-lager.jpg',
          description: 'Toasty malt complements beef while the crisp finish resets your taste buds. (Swap for iced hibiscus "agua de Jamaica" if you prefer non-alcoholic.)'
        }
      ]
    },
    { 
      id: 'plantain-beef', 
      name: 'Plantain and Beef', 
      images: ['/images/Plantain and Beef.png', '/images/plantain-beef-2.jpg'], 
      description: 'Sweet and savory plantain and beef bites.', 
      longDescription: `Experience the perfect blend of sweet and savory with our Plantain and Beef bites. Made with ripe plantains and seasoned beef, these bites offer a unique taste experience that captures the essence of Latin American cuisine. The natural sweetness of the plantains complements the savory beef to create a harmonious flavor profile that will leave you wanting more.`,
      pairings: [
        { 
          name: 'Venezuelan Guasacaca Sauce', 
          image: '/images/guasacaca-sauce.jpg',
          description: 'Creamy coolness + bright acidity & herbs lift the ripe-plantain sweetness and refresh the beef filling.'
        },
        { 
          name: 'Argentine Chimichurri', 
          image: '/images/argentine-chimichurri.jpg',
          description: 'Lively acidity and dried herbs cut through fat and echo any smoky char on the meat.'
        },
        { 
          name: 'Peruvian Ají Amarillo Cream', 
          image: '/images/aji-amarillo-cream.jpg',
          description: 'Floral heat and citrus balance the beef\'s richness and contrast the plantain\'s soft sweetness.'
        },
        { 
          name: 'Salvadoran Curtido', 
          image: '/images/curtido.jpg',
          description: 'Crunchy, tangy and lightly herbal — resets the palate and adds texture.'
        },
        { 
          name: 'Mango Pico de Gallo', 
          image: '/images/mango-pico.jpg',
          description: 'Fresh tropical fruit and limey bite amplify plantain notes without cloying.'
        },
        { 
          name: 'Cuban Garlic Mojo', 
          image: '/images/garlic-mojo.jpg',
          description: 'Toasted garlic deepens the beef; sharp citrus wakes up every bite.'
        },
        { 
          name: 'Classic Mexican Michelada', 
          image: '/images/michelada.jpg',
          description: 'Effervescence, acidity & gentle heat cleanse between bites.'
        },
        { 
          name: 'Peruvian Chicha Morada', 
          image: '/images/chicha-morada.jpg',
          description: 'Fruity-spiced refresher that harmonizes with plantain caramel.'
        }
      ]
    },
    { 
      id: 'plantain-cheese', 
      name: 'Plantain and Cheese', 
      images: ['/images/Plantain and cheese.png', '/images/plantain-cheese-2.jpg'], 
      description: 'Creamy plantain and cheese bites, a delightful treat.', 
      longDescription: `Our Plantain and Cheese bites offer the perfect combination of sweet plantains and creamy cheese. These delightful treats are great as an appetizer or a snack and showcase the versatility of plantains in Latin American cuisine. The natural sweetness of the ripe plantains balances perfectly with the savory cheese, creating a harmonious blend of flavors that will satisfy any palate.`,
      pairings: [
        { 
          name: 'Guava–Jalapeño Jam', 
          image: '/images/guava-jalapeno-jam.jpg',
          description: 'Tropical sweetness echoes ripe plantain; a mild chile zing keeps the melted cheese lively, not heavy.'
        },
        { 
          name: 'Cilantro–Lime Crema', 
          image: '/images/cilantro-lime-crema.jpg',
          description: 'Cool dairy + bright citrus lighten the fried exterior and add a fresh, herby snap.'
        },
        { 
          name: 'Pineapple Habanero Escabeche', 
          image: '/images/pineapple-escabeche.jpg',
          description: 'Crunchy, tangy pickled pineapple and veggies reset the palate with sweet-heat and add texture.'
        },
        { 
          name: 'Mexican Cola on Ice with Lime', 
          image: '/images/mexican-cola.jpg',
          description: 'Real-sugar cola\'s vanilla–caramel notes match plantain sugars, while lime juice cuts through richness.'
        },
        { 
          name: 'Chilled Malta Beverage', 
          image: '/images/malta-beverage.jpg',
          description: 'Malty, lightly caramelized soda mirrors plantain\'s sweetness, complements salty cheese, and keeps it alcohol-free.'
        }
      ]
    },
    { 
      id: 'mandocas', 
      name: 'Mandocas', 
      images: ['/images/mandocas.png', '/images/mandocas-2.jpg'], 
      description: 'Traditional mandocas, a sweet and crispy delight.', 
      longDescription: `Mandocas are a traditional Venezuelan treat made with corn flour, ripe plantains, and cheese, shaped into rings and fried to perfection. These sweet and slightly savory rings have a crispy exterior and a soft interior, creating a delightful texture contrast. Mandocas are a beloved breakfast item in Venezuela but make for a perfect snack or dessert any time of the day.`,
      pairings: [
        { 
          name: 'Salty Venezuelan Queso Blanco Crumbles', 
          image: '/images/queso-blanco.jpg',
          description: 'The firm, salty cheese melts lightly over the warm corn-plantain ring and balances its natural sweetness.'
        },
        { 
          name: 'Warm Maple Syrup Drizzle', 
          image: '/images/maple-syrup.jpg',
          description: 'Deep caramel notes echo the ripe plantain while the silky texture coats every bite.'
        },
        { 
          name: 'Thick Hot Chocolate (Abuelita-style)', 
          image: '/images/hot-chocolate.jpg',
          description: 'Rich cocoa and subtle cinnamon make a classic dunking combo that turns mandocas into an indulgent breakfast treat.'
        },
        { 
          name: 'Guava Paste & Cream Cheese Duo', 
          image: '/images/guava-cream-cheese.jpg',
          description: 'Tangy cream cheese tamps the bright tropical sweetness of guava, adding fruity contrast in a single swipe.'
        },
        { 
          name: 'Brown Sugar–Cinnamon Butter', 
          image: '/images/cinnamon-butter.jpg',
          description: 'Whipped butter infused with papelón (raw cane sugar) and spice seeps into the crispy ridges, creating a churro-like vibe.'
        }
      ]
    },
    { id: 'mini-empanadas-beef', name: 'Mini Empanadas Beef', images: ['/images/Mini Empanada Empanada Beef.png', '/images/mini-empanadas-beef-2.jpg'], description: 'Mini beef empanadas, packed with flavor.', longDescription: `Our Mini Beef Empanadas are filled with perfectly seasoned ground beef, onions, peppers, and a blend of spices that create an explosion of flavor in every bite. These small but mighty empanadas have a crispy exterior that gives way to a juicy, flavorful filling. Perfect for parties or as an appetizer, these mini empanadas showcase the classic flavors of Latin American cuisine in a convenient, bite-sized package.` },
    { id: 'mini-empanadas-chicken', name: 'Mini Empanadas Chicken', images: ['/images/Chicken Mini Empandas.png', '/images/mini-empanadas-chicken-2.jpg'], description: 'Mini chicken empanadas, a perfect appetizer.', longDescription: `Our Mini Chicken Empanadas feature tender, seasoned chicken encased in a perfectly crispy pastry. Each empanada is carefully crafted to ensure a balance of flavors that captures the essence of authentic Latin cuisine. These bite-sized delights are perfect for entertaining guests or enjoying as a quick, flavorful snack. The combination of our special seasoning and quality chicken creates a memorable taste experience in every bite.` },
    { id: 'mini-empanadas-spinach', name: 'Mini Empanadas Spinach and Cheese', images: ['/images/Mini Spinach and Cheese.png', '/images/mini-empanadas-spinach-2.jpg'], description: 'Mini spinach and cheese empanadas, a vegetarian favorite.', longDescription: `Our Mini Spinach and Cheese Empanadas offer a delicious vegetarian option that doesn't compromise on flavor. Filled with fresh spinach and a blend of cheeses, these empanadas provide a creamy, savory filling encased in a crispy pastry shell. The combination of earthy spinach and rich cheese creates a balanced flavor profile that appeals to vegetarians and meat-eaters alike. Perfect for adding variety to your appetizer spread or enjoying as a satisfying snack.` }
  ],
  'empanadas': [
    { id: 'beef-empanada', name: 'Beef Empanada', images: ['/images/BeefEmpanada.png', '/images/beef-empanada-2.jpg'], description: 'Classic beef empanadas with a savory filling.', longDescription: `Our Beef Empanadas feature a perfectly seasoned ground beef filling with onions, peppers, garlic, and a blend of traditional spices, all encased in a flaky, golden pastry. Each empanada is carefully crafted to ensure the perfect balance of filling and pastry. These empanadas are a staple in Latin American cuisine and a customer favorite, offering a portable, satisfying meal that's packed with authentic flavors.` },
    { id: 'chicken-empanada', name: 'Chicken Empanada', images: ['/images/EmpanadaPollo.png', '/images/chicken-empanada-2.jpg'], description: 'Flavorful chicken empanadas, a crowd pleaser.', longDescription: `Our Chicken Empanadas contain tender, seasoned chicken combined with vegetables and spices, wrapped in a golden, flaky crust. The filling is carefully prepared to ensure the chicken remains juicy and flavorful. Each bite offers a perfect balance of savory chicken and crispy pastry, making these empanadas a versatile option for any occasion, from casual gatherings to formal events.` }
  ],
  'prepared-meals': [
    { 
      id: 'ropa-vieja', 
      name: 'Ropa Vieja / Shredded Beef', 
      images: ['/images/RopaVieja.png', '/images/Mechada.png'], 
      description: 'Traditional slow-cooked shredded beef in a flavorful tomato sauce.', 
      longDescription: `Our Ropa Vieja is a classic Cuban dish featuring tender shredded beef slow-cooked in a rich tomato sauce with bell peppers, onions, and a blend of traditional Latin spices. The name "Ropa Vieja" translates to "old clothes," referring to the shredded appearance of the beef that resembles tattered clothes. This hearty, flavorful dish is perfect served with rice, beans, and sweet plantains for an authentic Latin American meal experience.`,
      ingredients: [
        'Prime flank steak', 
        'Garlic cloves', 
        'Red bell peppers', 
        'Green bell peppers', 
        'Yellow onions', 
        'Tomato sauce', 
        'Dry white wine', 
        'Bay leaves', 
        'Cumin', 
        'Oregano', 
        'Salt and pepper'
      ],
      nutrition: {
        'Calories': '320 kcal',
        'Protein': '28g',
        'Carbohydrates': '12g',
        'Fat': '16g',
        'Fiber': '3g',
        'Sodium': '580mg',
        'Serving Size': '6 oz (170g)'
      },
      preparation: [
        'Thaw product completely in refrigerator if frozen.',
        'Transfer to a microwave-safe container and heat for 2-3 minutes on high, stirring halfway through.',
        'Alternatively, heat in a pan over medium heat for 5-7 minutes, stirring occasionally.',
        'For best flavor, add a splash of water or broth when reheating to maintain moisture.',
        'Serve hot with rice, beans, or as a filling for arepas or tortillas.',
        'Garnish with fresh cilantro and lime wedges before serving.'
      ],
      pairings: [
        { 
          name: 'White Rice & Black Beans', 
          image: '/images/RopaVieja.png',
          description: 'The classic accompaniment to Ropa Vieja, providing the perfect base for this flavorful beef.'
        },
        { 
          name: 'Sweet Plantains', 
          image: '/images/sweet-plantains.jpg',
          description: 'The sweetness of ripe plantains balances the savory flavors of the shredded beef.'
        },
        { 
          name: 'Avocado Salad', 
          image: '/images/avocado-salad.jpg',
          description: 'A fresh, creamy contrast to the rich flavors of the beef.'
        }
      ]
    },
    { 
      id: 'pollo-esmechado', 
      name: 'Pollo Esmechado', 
      images: ['/images/PolloEsmechado.png', '/images/pollo-esmechado-2.jpg'], 
      description: 'Flavorful shredded chicken prepared with traditional seasonings.', 
      longDescription: `Our Pollo Esmechado features tender chicken that's been slow-cooked, shredded, and then sautéed with onions, bell peppers, and a blend of Latin American spices. This Venezuelan specialty is known for its rich flavor and versatility. The chicken remains juicy while absorbing all the savory elements of the dish, making it perfect as a main course with traditional sides or as a filling for arepas, empanadas, or sandwiches.`,
      ingredients: [
        'Chicken breast', 
        'Yellow onions', 
        'Red bell peppers', 
        'Garlic', 
        'Cilantro', 
        'Adobo seasoning', 
        'Chicken broth', 
        'Olive oil', 
        'Salt and pepper'
      ],
      nutrition: {
        'Calories': '250 kcal',
        'Protein': '32g',
        'Carbohydrates': '8g',
        'Fat': '11g',
        'Fiber': '2g',
        'Sodium': '520mg',
        'Serving Size': '6 oz (170g)'
      },
      preparation: [
        'Thaw product completely in refrigerator if frozen.',
        'Heat in microwave for 2-3 minutes on high, stirring halfway through.',
        'Alternatively, warm in a pan over medium heat for 4-5 minutes.',
        'Add a small amount of water or broth when reheating to maintain moisture.',
        'Serve hot with your choice of sides or use as a filling for arepas.',
        'Garnish with fresh cilantro and a squeeze of lime juice for extra flavor.'
      ],
      pairings: [
        { 
          name: 'Arepas', 
          image: '/images/arepas.jpg',
          description: 'Traditional Venezuelan corn cakes that pair perfectly with shredded chicken.'
        },
        { 
          name: 'Fried Yuca', 
          image: '/images/fried-yuca.jpg',
          description: 'Crispy on the outside, soft on the inside, these yuca fries complement the chicken perfectly.'
        },
        { 
          name: 'Tomato Avocado Salad', 
          image: '/images/tomato-avocado.jpg',
          description: 'A refreshing side that balances the savory chicken with fresh flavors.'
        }
      ]
    },
    { 
      id: 'barbacoa', 
      name: 'Barbacoa', 
      images: ['/images/Barbacoa.png'], 
      description: 'Slow-cooked barbacoa with authentic Latin seasonings.', 
      longDescription: `Our Barbacoa is prepared using traditional Latin American methods, with meat that's been slow-cooked for hours until perfectly tender. Seasoned with a blend of chilies, garlic, cumin, and other authentic spices, this dish offers a rich, smoky flavor profile that's both complex and comforting. The slow cooking process ensures that every bite is moist, flavorful, and falls apart with just the touch of a fork.`,
      ingredients: [
        'Beef cheek or chuck roast', 
        'Dried guajillo chilies', 
        'Dried ancho chilies', 
        'Garlic cloves', 
        'Cumin', 
        'Oregano', 
        'Apple cider vinegar', 
        'Bay leaves', 
        'Cloves', 
        'Beef broth', 
        'Salt and pepper'
      ],
      nutrition: {
        'Calories': '310 kcal',
        'Protein': '30g',
        'Carbohydrates': '10g',
        'Fat': '18g',
        'Fiber': '2g',
        'Sodium': '550mg',
        'Serving Size': '6 oz (170g)'
      },
      preparation: [
        'Thaw completely in refrigerator if frozen.',
        'Warm in microwave for 2-3 minutes, stirring halfway through cooking.',
        'For stovetop, heat in a pan over medium heat for 5-7 minutes, stirring occasionally.',
        'Add a small amount of beef broth if needed to maintain moisture.',
        'Serve hot with tortillas and your favorite toppings.',
        'Garnish with chopped onions, cilantro, and lime wedges for authentic flavor.'
      ],
      pairings: [
        { 
          name: 'Corn Tortillas', 
          image: '/images/corn-tortillas.jpg',
          description: 'Traditional corn tortillas are the perfect vessel for this flavorful meat.'
        },
        { 
          name: 'Mexican Rice', 
          image: '/images/mexican-rice.jpg',
          description: 'Flavorful rice cooked with tomatoes and spices complements the rich barbacoa.'
        },
        { 
          name: 'Pico de Gallo', 
          image: '/images/pico-de-gallo.jpg',
          description: 'Fresh tomato salsa adds brightness to balance the rich, slow-cooked meat.'
        }
      ]
    },
    { 
      id: 'pork-belly', 
      name: 'Pork Belly', 
      images: ['/images/PorkBelly.png'], 
      description: 'Crispy yet tender pork belly with Latin-inspired flavors.', 
      longDescription: `Our Latin-inspired Pork Belly features the perfect balance of crispy skin and melt-in-your-mouth meat. Prepared with a blend of traditional Latin American seasonings and slow-cooked to perfection, this dish offers a luxurious eating experience. The rich, fatty nature of pork belly makes it ideal for absorbing the complex flavors of our marinade, resulting in a dish that's intensely satisfying and packed with authentic tastes.`,
      ingredients: [
        'Premium pork belly', 
        'Sea salt', 
        'Garlic', 
        'Orange juice', 
        'Lime juice', 
        'Oregano', 
        'Cumin', 
        'Paprika', 
        'Bay leaves', 
        'Olive oil'
      ],
      nutrition: {
        'Calories': '420 kcal',
        'Protein': '22g',
        'Carbohydrates': '4g',
        'Fat': '36g',
        'Fiber': '0g',
        'Sodium': '480mg',
        'Serving Size': '5 oz (140g)'
      },
      preparation: [
        'Preheat oven to 375°F (190°C).',
        'Place pork belly in an oven-safe dish and warm for 10-12 minutes until heated through and skin is crispy.',
        'For best results, finish under the broiler for 2-3 minutes to maximize crispiness.',
        'Allow to rest for 5 minutes before slicing.',
        'Slice into portions and serve immediately.',
        'Garnish with fresh herbs and a squeeze of citrus if desired.'
      ],
      pairings: [
        { 
          name: 'Yuca Mash', 
          image: '/images/yuca-mash.jpg',
          description: 'Creamy yuca mash makes the perfect base for rich, flavorful pork belly.'
        },
        { 
          name: 'Pickled Red Onions', 
          image: '/images/pickled-onions.jpg',
          description: 'Tangy, bright pickled onions cut through the richness of the pork.'
        },
        { 
          name: 'Crisp Green Salad', 
          image: '/images/green-salad.jpg',
          description: 'A light, fresh salad provides balance to the rich pork belly.'
        }
      ]
    },
    { 
      id: 'porchetta', 
      name: 'Porchetta', 
      images: ['/images/porchetta.jpg'], 
      description: 'Italian-Latin fusion porchetta with herbs and spices.', 
      longDescription: `Our Porchetta represents a beautiful fusion of Italian tradition and Latin American flavors. This boneless pork roast is seasoned with a blend of herbs, spices, and citrus that creates a harmonious balance of flavors. The meat is rolled, tied, and slow-roasted to achieve a crispy exterior while maintaining a juicy, tender interior. Sliced thin, our Porchetta offers an elegant yet comforting addition to any meal, showcasing the versatility of pork in Latin cuisine.`,
      ingredients: [
        'Pork belly and loin', 
        'Garlic', 
        'Fresh rosemary', 
        'Fresh thyme', 
        'Sage', 
        'Fennel seeds', 
        'Orange zest', 
        'Chili flakes', 
        'Olive oil', 
        'Sea salt', 
        'Black pepper'
      ],
      nutrition: {
        'Calories': '380 kcal',
        'Protein': '26g',
        'Carbohydrates': '2g',
        'Fat': '30g',
        'Fiber': '0g',
        'Sodium': '520mg',
        'Serving Size': '5 oz (140g)'
      },
      preparation: [
        'Preheat oven to 350°F (175°C).',
        'Place porchetta on a baking sheet and warm for 10-15 minutes.',
        'For crispy skin, finish under broiler for 2-3 minutes.',
        'Let rest for 5 minutes before slicing.',
        'Slice thinly against the grain and arrange on a serving platter.',
        'Serve warm with your choice of sides or as a filling for sandwiches.'
      ],
      pairings: [
        { 
          name: 'Roasted Vegetables', 
          image: '/images/roasted-vegetables.jpg',
          description: 'Colorful roasted vegetables complement the herb-infused porchetta perfectly.'
        },
        { 
          name: 'Chimichurri Sauce', 
          image: '/images/chimichurri.jpg',
          description: 'Fresh, herbaceous chimichurri adds brightness to the rich porchetta.'
        },
        { 
          name: 'Crusty Bread', 
          image: '/images/crusty-bread.jpg',
          description: 'Artisanal bread is perfect for creating delicious porchetta sandwiches.'
        }
      ]
    }
  ],
  'white-corn-empanadas': [
    { id: 'pabellon-empanada', name: 'Pabellón Empanada', images: ['/images/EmpaPabellon.png'], description: 'Venezuelan-style empanada with traditional pabellón filling.', longDescription: `Our Pabellón Empanada is a Venezuelan specialty featuring a corn-based shell filled with shredded beef, black beans, and sweet plantains - the components of Venezuela's national dish, Pabellón Criollo. This empanada offers a complete flavor experience in every bite, with the savory beef, earthy beans, and sweet plantains creating a perfect harmony. The corn-based shell adds a distinctive texture and flavor that sets Venezuelan empanadas apart from their pastry-based counterparts.` },
    { id: 'cheese-empanada', name: 'Cheese Empanada', images: ['/images/WhiteMasaCheese.png'], description: 'Simple yet delicious Venezuelan-style cheese empanada.', longDescription: `Our Venezuelan Cheese Empanada features a golden, crispy corn-based shell filled with a generous amount of melty, savory cheese. This simple yet incredibly satisfying empanada showcases the beauty of Venezuelan cuisine - uncomplicated ingredients coming together to create something truly delicious. The contrast between the crispy exterior and the gooey cheese filling makes each bite a delightful experience that keeps customers coming back for more.` },
    { id: 'mechada-empanada', name: 'Mechada Empanada', images: ['/images/EmpaVenMechada.png'], description: 'Venezuelan-style empanada with traditional mechada filling.', longDescription: `Our Pabellón Empanada is a Venezuelan specialty featuring a corn-based shell filled with shredded beef, black beans, and sweet plantains - the components of Venezuela's national dish, Pabellón Criollo. This empanada offers a complete flavor experience in every bite, with the savory beef, earthy beans, and sweet plantains creating a perfect harmony. The corn-based shell adds a distinctive texture and flavor that sets Venezuelan empanadas apart from their pastry-based counterparts.` },
    { id: 'polloes-empanada', name: 'Pollo Empanada', images: ['/images/EmpaVenPollo.png', '/images/cheese-empanada-2.jpg'], description: 'Simple yet delicious Venezuelan-style chicken empanada.', longDescription: `Our Venezuelan Cheese Empanada features a golden, crispy corn-based shell filled with a generous amount of melty, savory cheese. This simple yet incredibly satisfying empanada showcases the beauty of Venezuelan cuisine - uncomplicated ingredients coming together to create something truly delicious. The contrast between the crispy exterior and the gooey cheese filling makes each bite a delightful experience that keeps customers coming back for more.` }
  
  ]
};

// Página de Catálogo General
function Catalog() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [hoverCategory, setHoverCategory] = useState(null);
  
  const categories = [
    { id: 'all', name: 'ALL PRODUCTS' },
    { 
      id: 'bites', 
      name: 'BITES', 
      image: '/images/Bites.png', 
      description: 'Savor our Latin-inspired bite-sized treats, perfect for any occasion.',
      items: '8 products'
    },
    { 
      id: 'empanadas', 
      name: 'EMPANADAS', 
      image: '/images/Empanadas.png', 
      description: 'Traditional handmade empanadas with unique and flavorful fillings.',
      items: '6 products'
    },
    { 
      id: 'prepared-meals', 
      name: 'PREPARED MEALS', 
      image: '/images/Mechada.png', 
      description: 'Traditional Latin American prepared meals featuring authentic recipes and flavors.',
      items: '5 products'
    },
    { 
      id: 'white-corn-empanadas', 
      name: 'WHITE CORN EMPANADAS', 
      image: '/images/venezolanas.png', 
      description: 'Authentic white corn empanadas with traditional corn-based shells.',
      items: '5 products'
    }
  ];
  
  const viewCategory = (categoryId) => {
    navigate(`/catalog/${categoryId}`);
  };

  const filteredCategories = categories.filter(
    category => category.id === 'all' || 
    category.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (category.description && category.description.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  
  return (
    <div className="catalog-page">
      <div className="catalog-hero">
        <h1>DISCOVER OUR<br/>AUTHENTIC FLAVORS</h1>
        <p>Explore our selection of handmade Latin American specialties</p>
      </div>
      
      <div className="catalog-tools">
        <div className="catalog-search">
          <input 
            type="text" 
            placeholder="Search categories..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="catalog-filter">
          {categories.map(category => (
            <button 
              key={category.id}
              className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>
      </div>
      
      <div className="category-grid">
        {filteredCategories
          .filter(category => activeCategory === 'all' || category.id === activeCategory)
          .filter(category => category.id !== 'all')
          .map((category) => (
            <div 
              key={category.id} 
              className="category-card" 
              onClick={() => viewCategory(category.id)}
              onMouseEnter={() => setHoverCategory(category.id)}
              onMouseLeave={() => setHoverCategory(null)}
            >
              <div className="category-image">
                <img src={category.image} alt={category.name} />
                <div className="category-overlay">
                  <span>EXPLORE</span>
                </div>
              </div>
              <div className="category-info">
                <div className="category-badge">{category.items}</div>
                <h2>{category.name}</h2>
                <p>{category.description}</p>
                <button className="view-category-btn">
                  {hoverCategory === category.id ? 'View Now' : 'View Products'}
                </button>
              </div>
            </div>
          ))
        }
      </div>
      
      {filteredCategories.length === 0 && (
        <div className="no-results">
          <h3>No categories found matching your search</h3>
          <p>Try different terms or explore all our categories</p>
          <button className="reset-search" onClick={() => setSearchTerm('')}>View All Categories</button>
        </div>
      )}
      
      <div className="catalog-cta">
        <h2>LOOKING FOR CUSTOM ORDERS?</h2>
        <p>We offer custom catering packages for events of all sizes</p>
        <Link to="/contact" className="cta-button">Contact Us</Link>
      </div>
    </div>
  );
}

// Página de Catálogo por Categoría
function CategoryCatalog() {
  const { category } = useParams();
  const navigate = useNavigate();
  const [sortOrder, setSortOrder] = useState('default');
  const [viewMode, setViewMode] = useState('grid');
  const [selectedProduct, setSelectedProduct] = useState(null);
  
  const products = productsData[category] || [];
  
  const viewProductDetail = (productId) => {
    navigate(`/product/${category}/${productId}`);
  };

  const handleQuickView = (e, product) => {
    e.stopPropagation();
    setSelectedProduct(product);
  };

  const closeQuickView = () => {
    setSelectedProduct(null);
  };
  
  const sortedProducts = [...products].sort((a, b) => {
    if (sortOrder === 'name-asc') return a.name.localeCompare(b.name);
    if (sortOrder === 'name-desc') return b.name.localeCompare(a.name);
    return 0; // default order
  });

  // Traducir nombre de categoría
  const getCategoryName = () => {
    switch(category) {
      case 'bites': return 'BITES';
      case 'empanadas': return 'EMPANADAS';
      case 'prepared-meals': return 'PREPARED MEALS';
      case 'white-corn-empanadas': return 'WHITE CORN EMPANADAS';
      default: return category.replace(/-/g, ' ').toUpperCase();
    }
  };
  
  return (
    <div className="category-catalog">
      <div className="catalog-header">
        <h1>{getCategoryName()}</h1>
        <p>Explore our selection of {category.replace(/-/g, ' ')} products</p>
      </div>
      
      <div className="catalog-controls">
        <div className="view-toggle">
          <button 
            className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`} 
            onClick={() => setViewMode('grid')}
          >
            Grid View
          </button>
          <button 
            className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`} 
            onClick={() => setViewMode('list')}
          >
            List View
          </button>
        </div>
        
        <div className="sort-controls">
          <label>Sort by: </label>
          <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
            <option value="default">Featured</option>
            <option value="name-asc">Name (A-Z)</option>
            <option value="name-desc">Name (Z-A)</option>
          </select>
        </div>
      </div>
      
      <div className={`catalog-tiles ${viewMode}`}>
        {sortedProducts.map((product) => (
          <div key={product.id} className="catalog-tile" onClick={() => viewProductDetail(product.id)}>
            <div className="product-image">
              <img src={product.images[0]} alt={product.name} />
              <div className="product-badge">AUTHENTIC</div>
              <div className="product-hover-overlay">
                <div className="overlay-content">
                  <h3>{product.name}</h3>
                  <button className="hover-btn" onClick={() => viewProductDetail(product.id)}>View Details</button>
                </div>
              </div>
            </div>
            <div className="product-info">
              <h3>{product.name}</h3>
              <p>{product.description}</p>
              <div className="product-actions">
                <button className="view-details-btn">View Details</button>
                <button className="quick-view-btn" onClick={(e) => handleQuickView(e, product)}>Quick View</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {selectedProduct && (
        <div className="quick-view-modal" onClick={closeQuickView}>
          <div className="quick-view-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={closeQuickView}>×</button>
            <div className="quick-view-image">
              <img src={selectedProduct.images[0]} alt={selectedProduct.name} />
            </div>
            <div className="quick-view-details">
              <h2>{selectedProduct.name}</h2>
              <p>{selectedProduct.longDescription}</p>
              <button 
                className="view-full-details" 
                onClick={() => viewProductDetail(selectedProduct.id)}
              >
                View Full Details
              </button>
            </div>
          </div>
        </div>
      )}
      
      <div className="catalog-navigation">
        <Link to="/catalog" className="back-to-categories">← Back to All Categories</Link>
      </div>
    </div>
  );
}

// Página de Detalle de Producto
function ProductDetail() {
  const { category, productId } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeTab, setActiveTab] = useState('description');
  const [activeSection, setActiveSection] = useState('product-info');
  const [fullscreenActive, setFullscreenActive] = useState(false);
  const [pairingModalActive, setPairingModalActive] = useState(false);
  const [selectedPairing, setSelectedPairing] = useState(null);
  
  // Buscar el producto
  const products = productsData[category] || [];
  const product = products.find(p => p.id === productId);
  
  if (!product) {
    return <div className="product-not-found">Product not found</div>;
  }

  // Función para manejar el cambio de sección
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 100,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };
  
  return (
    <div className="product-detail-page">
      {/* Header con navegación del producto y breadcrumbs */}
      <div className="product-header">
        <div className="product-breadcrumbs">
          <Link to="/">Home</Link> / 
          <Link to="/catalog"> Catalog</Link> / 
          <Link to={`/catalog/${category}`}> {category.replace(/-/g, ' ')}</Link> / 
          <span> {product.name}</span>
        </div>

        <div className="product-navigation">
          <button 
            className={`nav-section-btn ${activeSection === 'product-info' ? 'active' : ''}`}
            onClick={() => scrollToSection('product-info')}
          >
            Product Info
          </button>
          <button 
            className={`nav-section-btn ${activeSection === 'product-details' ? 'active' : ''}`}
            onClick={() => scrollToSection('product-details')}
          >
            Details & Ingredients
          </button>
          <button 
            className={`nav-section-btn ${activeSection === 'pairing-suggestions' ? 'active' : ''}`}
            onClick={() => scrollToSection('pairing-suggestions')}
          >
            Perfect Pairings
          </button>
          <button 
            className={`nav-section-btn ${activeSection === 'related-products' ? 'active' : ''}`}
            onClick={() => scrollToSection('related-products')}
          >
            Similar Products
          </button>
        </div>
      </div>

      {/* Sección principal de información del producto */}
      <div id="product-info" className="product-section">
        <div className="product-detail-container">
          <div className="product-gallery">
            <div 
              className="main-image" 
              onClick={() => setFullscreenActive(true)}
            >
              <img src={product.images[selectedImage]} alt={product.name} />
              <div className="gallery-controls">
                <button 
                  className="gallery-arrow prev" 
                  onClick={(e) => {
                    e.stopPropagation(); // Evitar que se abra fullscreen al hacer click en los controles
                    setSelectedImage(prev => (prev === 0 ? product.images.length - 1 : prev - 1));
                  }}
                >
                  &#10094;
                </button>
                <button 
                  className="gallery-arrow next" 
                  onClick={(e) => {
                    e.stopPropagation(); // Evitar que se abra fullscreen al hacer click en los controles
                    setSelectedImage(prev => (prev === product.images.length - 1 ? 0 : prev + 1));
                  }}
                >
                  &#10095;
                </button>
              </div>
            </div>
            <div className="thumbnail-images">
              {product.images.map((image, index) => (
                <div 
                  key={index} 
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                >
                  <img src={image} alt={`${product.name} view ${index + 1}`} />
                </div>
              ))}
            </div>
            
            <div className="image-counter">
              <span>{selectedImage + 1}/{product.images.length}</span>
            </div>
          </div>
          
          {/* Overlay para vista a pantalla completa */}
          <div 
            className={`fullscreen-overlay ${fullscreenActive ? 'active' : ''}`}
            onClick={() => setFullscreenActive(false)}
          >
            <button 
              className="close-fullscreen" 
              onClick={(e) => {
                e.stopPropagation();
                setFullscreenActive(false);
              }}
            >
              ✕
            </button>
            <div className="fullscreen-nav">
              <button 
                className="fullscreen-arrow prev" 
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(prev => (prev === 0 ? product.images.length - 1 : prev - 1));
                }}
              >
                &#10094;
              </button>
              <button 
                className="fullscreen-arrow next" 
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(prev => (prev === product.images.length - 1 ? 0 : prev + 1));
                }}
              >
                &#10095;
              </button>
            </div>
            <img 
              src={product.images[selectedImage]} 
              alt={product.name} 
              className="fullscreen-image" 
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          
          <div className="product-info-content">
            <div className="product-header-info">
              <h1>{product.name}</h1>
              <div className="product-badges">
                <span className="badge authentic">Authentic</span>
                <span className="badge premium">Premium</span>
                <span className="badge category">{category.replace(/-/g, ' ')}</span>
              </div>
              <div className="product-summary">
                {product.description}
              </div>
            </div>
            
            <div className="product-options">
              <h2>PURCHASE OPTIONS</h2>
              <div className="option-buttons">
                <button className="option-btn active">Retail</button>
                <button className="option-btn">Wholesale</button>
              </div>
              
              <div className="product-actions">
                <button className="inquiry-btn" onClick={() => scrollToSection('product-details')}>VIEW DETAILS</button>
                <button className="wholesale-btn">CONTACT FOR PRICING</button>
              </div>
            </div>
            
            <div className="how-to-use">
              <h3>HOW TO USE THIS PRODUCT</h3>
              <div className="usage-steps">
                <div className="usage-step">
                  <div className="step-icon">1</div>
                  <div className="step-text">
                    <h4>Choose your option</h4>
                    <p>Select retail or wholesale depending on your needs</p>
                  </div>
                </div>
                <div className="usage-step">
                  <div className="step-icon">2</div>
                  <div className="step-text">
                    <h4>Review product details</h4>
                    <p>Check ingredients and nutritional information below</p>
                  </div>
                </div>
                <div className="usage-step">
                  <div className="step-icon">3</div>
                  <div className="step-text">
                    <h4>Contact us</h4>
                    <p>Reach out via the contact button for pricing and orders</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Sección de detalles del producto */}
      <div id="product-details" className="product-section details-section">
        <div className="section-title-container">
          <h2 className="section-title">PRODUCT DETAILS</h2>
          <div className="section-divider"></div>
        </div>
        
        <div className="product-details-container">
          <div className="product-tabs">
            <div className="tab-navigation">
              <button 
                className={`tab-btn ${activeTab === 'description' ? 'active' : ''}`}
                onClick={() => setActiveTab('description')}
              >
                Description
              </button>
              <button 
                className={`tab-btn ${activeTab === 'ingredients' ? 'active' : ''}`}
                onClick={() => setActiveTab('ingredients')}
              >
                Ingredients
              </button>
              <button 
                className={`tab-btn ${activeTab === 'nutrition' ? 'active' : ''}`}
                onClick={() => setActiveTab('nutrition')}
              >
                Nutrition
              </button>
              <button 
                className={`tab-btn ${activeTab === 'preparation' ? 'active' : ''}`}
                onClick={() => setActiveTab('preparation')}
              >
                Preparation
              </button>
            </div>
            
            <div className="tab-content">
              {activeTab === 'description' && (
                <div className="tab-panel description">
                  <h3>PRODUCT DESCRIPTION</h3>
                  <p>{product.longDescription || product.description}</p>
                  <div className="features-list">
                    <div className="feature">
                      <div className="feature-icon">✓</div>
                      <span>Authentic Latin American Recipe</span>
                    </div>
                    <div className="feature">
                      <div className="feature-icon">✓</div>
                      <span>Premium Quality Ingredients</span>
                    </div>
                    <div className="feature">
                      <div className="feature-icon">✓</div>
                      <span>Handcrafted with Care</span>
                    </div>
                    <div className="feature">
                      <div className="feature-icon">✓</div>
                      <span>Traditional Methods</span>
                    </div>
                  </div>
                </div>
              )}
              
              {activeTab === 'ingredients' && (
                <div className="tab-panel ingredients">
                  <h3>INGREDIENTS</h3>
                  <ul className="ingredients-list">
                    {product.ingredients ? (
                      product.ingredients.map((ingredient, idx) => (
                        <li key={idx} className="ingredient-item">
                          <span className="ingredient-icon">•</span>
                          <span className="ingredient-name">{ingredient}</span>
                        </li>
                      ))
                    ) : (
                      <p>Ingredients information coming soon.</p>
                    )}
                  </ul>
                  <div className="ingredients-note">
                    <div className="note-icon">ⓘ</div>
                    <p>All our ingredients are carefully selected to maintain the authentic Latin American flavors. No artificial preservatives or additives.</p>
                  </div>
                  <div className="allergens-info">
                    <h4>ALLERGEN INFORMATION</h4>
                    <p>May contain: wheat, dairy, eggs. Please contact us for detailed allergen information.</p>
                  </div>
                </div>
              )}
              
              {activeTab === 'nutrition' && (
                <div className="tab-panel nutrition">
                  <h3>NUTRITIONAL INFORMATION</h3>
                  {product.nutrition ? (
                    <>
                      <div className="nutrition-table">
                        <div className="nutrition-row header">
                          <span>Nutrient</span>
                          <span>Amount per Serving</span>
                        </div>
                        {Object.entries(product.nutrition).map(([nutrient, value], idx) => (
                          <div key={idx} className="nutrition-row">
                            <span className="nutrient">{nutrient}</span>
                            <span className="value">{value}</span>
                          </div>
                        ))}
                      </div>
                      <div className="nutrition-note">
                        <p>* Percent Daily Values are based on a 2,000 calorie diet. Your daily values may be higher or lower depending on your calorie needs.</p>
                      </div>
                    </>
                  ) : (
                    <p>Nutritional information coming soon.</p>
                  )}
                </div>
              )}
              
              {activeTab === 'preparation' && (
                <div className="tab-panel preparation">
                  <h3>PREPARATION STEPS</h3>
                  {product.preparation ? (
                    <div className="preparation-container">
                      <ol className="preparation-steps">
                        {product.preparation.map((step, idx) => (
                          <li key={idx} className="step-item">
                            <span className="step-number">{idx + 1}</span>
                            <div className="step-content">
                              <p>{step}</p>
                            </div>
                          </li>
                        ))}
                      </ol>
                      <div className="preparation-tips">
                        <h4>CHEF'S TIPS</h4>
                        <ul>
                          <li>For best flavor, let the product come to room temperature before serving</li>
                          <li>Garnish with fresh herbs or lime wedges for an extra touch</li>
                          <li>Store any leftovers in an airtight container in the refrigerator</li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <p>Preparation instructions coming soon.</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {/* Sección de sugerencias de maridaje */}
      <div id="pairing-suggestions" className="product-section pairing-section">
        <div className="section-title-container">
          <h2 className="section-title">PERFECT PAIRINGS</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">Enhance your meal with these recommended combinations</p>
        </div>
        
        <div className="pairing-items">
          {product.pairings ? product.pairings.map((pairing, idx) => (
            <div key={idx} className="pairing-item">
              <div className="pairing-image">
                <img src={pairing.image} alt={pairing.name} />
              </div>
              <div className="pairing-info">
                <h3>{pairing.name}</h3>
                <p>{pairing.description}</p>
                <button 
                  className="pairing-btn"
                  onClick={() => {
                    setSelectedPairing(pairing);
                    setPairingModalActive(true);
                  }}
                >
                  View Recipe
                </button>
              </div>
            </div>
          )) : (
            <p className="no-pairings">Pairing suggestions coming soon.</p>
          )}
        </div>
        
        {/* Modal para las recetas de pairing */}
        <div className={`pairing-recipe-modal ${pairingModalActive ? 'active' : ''}`}>
          <div className="recipe-modal-content">
            <button 
              className="close-recipe-modal" 
              onClick={() => setPairingModalActive(false)}
            >
              ✕
            </button>
            
            {selectedPairing && (
              <>
                <div className="recipe-modal-header">
                  <h3>Perfect Pairing: {selectedPairing.name}</h3>
                  <div className="recipe-divider"></div>
                </div>
                
                <div className="recipe-modal-body">
                  <div className="recipe-image-container">
                    <img src={selectedPairing.image} alt={selectedPairing.name} />
                  </div>
                  
                  <div className="recipe-details">
                    <h4>Why It Works</h4>
                    <p>{selectedPairing.description}</p>
                    
                    <h4>How to Serve</h4>
                    <div className="recipe-instructions">
                      <div className="instruction-step">
                        <div className="step-number">1</div>
                        <p>Prepare {product.name} according to instructions.</p>
                      </div>
                      <div className="instruction-step">
                        <div className="step-number">2</div>
                        <p>Serve with freshly prepared {selectedPairing.name}.</p>
                      </div>
                      <div className="instruction-step">
                        <div className="step-number">3</div>
                        <p>Garnish with fresh herbs and citrus for added flavor.</p>
                      </div>
                    </div>
                    
                    <h4>Chef's Tip</h4>
                    <p className="chef-tip">
                      For the best flavor experience, serve {product.name} alongside {selectedPairing.name} on a warmed plate. 
                      This combination highlights the authentic Latin flavors and creates a balanced, satisfying meal.
                    </p>
                  </div>
                </div>
                
                <div className="recipe-modal-footer">
                  <button className="recipe-action-btn" onClick={() => setPairingModalActive(false)}>Close</button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      
      {/* Sección de productos relacionados */}
      <div id="related-products" className="product-section related-section">
        <div className="section-title-container">
          <h2 className="section-title">YOU MAY ALSO LIKE</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">Other products from our authentic collection</p>
        </div>
        
        <div className="related-product-tiles">
          {products.filter(p => p.id !== productId).slice(0, 4).map((relatedProduct) => (
            <div key={relatedProduct.id} className="related-product-tile" onClick={() => window.location.href = `/product/${category}/${relatedProduct.id}`}>
              <div className="related-product-image">
                <img src={relatedProduct.images[0]} alt={relatedProduct.name} />
                <div className="related-product-overlay">
                  <span>VIEW PRODUCT</span>
                </div>
              </div>
              <h3>{relatedProduct.name}</h3>
              <p className="related-product-desc">{relatedProduct.description}</p>
            </div>
          ))}
        </div>
      </div>
      
      {/* CTA final */}
      <div className="product-cta">
        <h2>READY TO ORDER?</h2>
        <p>Contact us for pricing, bulk orders, or special requests</p>
        <div className="cta-buttons">
          <Link to="/contact" className="cta-primary-btn">CONTACT US NOW</Link>
          <button onClick={() => scrollToSection('product-info')} className="cta-secondary-btn">BACK TO TOP</button>
        </div>
      </div>
    </div>
  );
}

// Páginas adicionales
function About() {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Header section */}
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>OUR STORY</h1>
          <div className="section-divider"></div>
          <p>Sharing the authentic taste of Latin America</p>
        </div>
      </div>
      
      {/* Main content section */}
      <div className="about-content">
        <div className="about-mission">
          <div className="mission-text">
            <h2>About Us</h2>
            <div className="section-divider"></div>
            <p>
              At Pashanga, we believe food is more than nourishment — it's memory, connection, and celebration.
            </p>
            <p>
              Born from the rich flavors of Latin America, our mission is to bring people together around food that feels like home. 
              Each recipe is a tribute to our roots — the hands that folded empanadas at family gatherings, the laughter that 
              echoed through shared meals, and the ingredients that speak the language of our lands.
            </p>
            <p>
              We make Latin food with heart. Crafted with love and bold flavors, our products are designed to sit proudly on your table, 
              turning everyday moments into joyful memories. Whether it's a quick bite or a feast with friends, 
              we're here to remind you of the warmth of tradition — and the power of gathering.
            </p>
            <p>
              Pashanga is for those who love, who remember, who celebrate.
              Pull up a chair. You're always welcome at our table.
            </p>
          </div>
          <div className="mission-image">
            <img src="/images/latin-food.jpg" alt="Latin American food tradition" />
          </div>
        </div>
        
        <div className="about-values">
          <div className="values-header">
            <h2>OUR VALUES</h2>
            <div className="section-divider"></div>
            <p>What drives us every day</p>
          </div>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <span>❤️</span>
              </div>
              <h3>Authenticity</h3>
              <p>We honor traditional recipes and techniques, creating food that's true to our heritage.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <span>🌟</span>
              </div>
              <h3>Quality</h3>
              <p>We use only the finest ingredients to ensure every bite delivers exceptional flavor.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <span>🤝</span>
              </div>
              <h3>Community</h3>
              <p>We believe in the power of food to bring people together and create lasting connections.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <span>🌱</span>
              </div>
              <h3>Tradition</h3>
              <p>We preserve cultural culinary traditions while adding our own creative touch.</p>
            </div>
          </div>
        </div>
        
        <div className="about-journey">
          <div className="journey-image">
            <img src="/images/Empanadas.png" alt="Our journey" />
          </div>
          <div className="journey-text">
            <h2>Our Journey</h2>
            <div className="section-divider"></div>
            <p>
              From family recipes to your table, our journey has been guided by passion and driven by a love for our Latin American heritage.
            </p>
            <p>
              Each product we create is a celebration of the diverse flavors and culinary traditions that make Latin American 
              cuisine so special. We've carefully crafted our recipes to deliver authentic tastes that transport you 
              to the vibrant streets and warm homes of Latin America.
            </p>
            <p>
              Our commitment is to continue sharing these flavors while building a community around the table, 
              where stories are shared and memories are made.
            </p>
            <Link to="/catalog" className="btn primary-btn">EXPLORE OUR PRODUCTS</Link>
          </div>
        </div>
      </div>
      
      {/* CTA section */}
      <div className="about-cta">
        <h2>JOIN US AT THE TABLE</h2>
        <p>Experience the authentic flavors of Latin America</p>
        <Link to="/contact" className="cta-button">CONTACT US</Link>
      </div>
    </div>
  );
}

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'General Inquiry',
    message: '',
    company: '',
    phone: ''
  });
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: false,
    message: ''
  });
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus({
        submitted: false,
        error: true,
        message: 'Please fill in all required fields.'
      });
      return;
    }
    
    // Simular envío exitoso
    setFormStatus({
      submitted: true,
      error: false,
      message: 'Thank you for your message! We will get back to you soon.'
    });
    
    // Reset form after successful submission
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        subject: 'General Inquiry',
        message: '',
        company: '',
        phone: ''
      });
    }, 500);
  };

  return (
    <div className="contact-page">
      {/* Hero section */}
      <div className="contact-hero">
        <div className="contact-hero-content">
          <h1>GET IN TOUCH</h1>
          <div className="section-divider"></div>
          <p>We'd love to hear from you! Contact us for inquiries, orders, or just to say hello.</p>
        </div>
      </div>
      
      <div className="contact-content">
        <div className="contact-info-container">
          <div className="contact-form-section">
            <h2>Send Us a Message</h2>
            <div className="section-divider"></div>
            
            {formStatus.submitted ? (
              <div className="form-success">
                <div className="success-icon">✓</div>
                <h3>Message Sent!</h3>
                <p>{formStatus.message}</p>
                <button 
                  className="reset-form-btn"
                  onClick={() => setFormStatus({ submitted: false, error: false, message: '' })}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                {formStatus.error && (
                  <div className="form-error">
                    <p>{formStatus.message}</p>
                  </div>
                )}
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name <span className="required">*</span></label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your full name"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Email Address <span className="required">*</span></label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Your email address"
                      required
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone (Optional)</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Your phone number"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="company">Company (Optional)</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Your company name"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="subject">Subject <span className="required">*</span></label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="Wholesale">Wholesale Inquiry</option>
                    <option value="Order Question">Order Question</option>
                    <option value="Product Feedback">Product Feedback</option>
                    <option value="Partnership">Partnership Opportunity</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message <span className="required">*</span></label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="How can we help you?"
                    rows="5"
                    required
                  ></textarea>
                </div>
                
                <div className="form-notice">
                  <p><span className="required">*</span> Required fields</p>
                  <p className="privacy-note">
                    By submitting this form, you agree to our 
                    <a href="#"> Privacy Policy</a>.
                  </p>
                </div>
                
                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            )}
          </div>
          
          <div className="contact-info-section">
            <h2>Contact Information</h2>
            <div className="section-divider"></div>
            
            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="method-details">
                  <h3>Phone</h3>
                  <p>(123) 456-7890</p>
                  <p className="detail-note">Monday to Friday, 9am - 6pm</p>
                </div>
              </div>
              
              <div className="contact-method">
                <div className="method-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="method-details">
                  <h3>Email</h3>
                  <p>info@pashanga.com</p>
                  <p className="detail-note">We'll respond as soon as possible</p>
                </div>
              </div>
              
              <div className="contact-method">
                <div className="method-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="method-details">
                  <h3>Location</h3>
                  <p>370 Ansin Blvd, Hallandale, FL 33009</p>
                  <p className="detail-note">Visit our production facility</p>
                </div>
              </div>
            </div>
            
            <div className="social-connect">
              <h3>Follow Us</h3>
              <div className="social-icons">
                <a href="https://instagram.com" className="social-icon" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://facebook.com" className="social-icon" aria-label="Facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://twitter.com" className="social-icon" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="https://tiktok.com" className="social-icon" aria-label="TikTok">
                  <i className="fab fa-tiktok"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="location-map">
          <h2>Find Us</h2>
          <div className="section-divider"></div>
          <div className="map-placeholder">
            <img src="/images/map-placeholder.jpg" alt="Location map" />
            <div className="map-overlay">
              <p>Map loading... click to view full map</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* CTA section */}
      <div className="contact-cta">
        <h2>INTERESTED IN OUR PRODUCTS?</h2>
        <p>Explore our delicious offerings and bring Latin American flavors to your table.</p>
        <Link to="/catalog" className="cta-button">VIEW OUR CATALOG</Link>
      </div>
    </div>
  );
}

// Componente principal de la aplicación
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

// Componente interno que tiene acceso al router
function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  useEffect(() => {
    // Añadir o quitar la clase home-page dependiendo de si estamos en la página principal
    if (isHomePage) {
      document.body.classList.add('home-page');
    } else {
      document.body.classList.remove('home-page');
    }
    
    // Limpieza al desmontar el componente
    return () => {
      document.body.classList.remove('home-page');
    };
  }, [isHomePage]);
  
  return (
    <div className="app">
      <Navigation />
      
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/catalog/:category" element={<CategoryCatalog />} />
          <Route path="/product/:category/:productId" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/images/whitelogo.png" alt="Pashanga" />
            <p>Authentic Latin American food celebrating the richness of our culinary traditions.</p>
          </div>
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/catalog">Catalog</Link></li>
              <li><Link to="/catalog/empanadas">Empanadas</Link></li>
              <li><Link to="/catalog/prepared-meals">Prepared Meals</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <p>Email: info@pashanga.com</p>
            <p>Phone: (305) 979-9660</p>
            <p>Address: 370 Ansin Blvd, Hallandale, FL 33009</p>
            <div className="social-links">
              <a href="https://instagram.com" className="social-link">Instagram</a>
              <a href="https://facebook.com" className="social-link">Facebook</a>
              <a href="https://twitter.com" className="social-link">Twitter</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Pashanga. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
